import React, { useEffect, useState } from "react";
import { FAQ } from "../../ApiServices/FAQ/FAQApi";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { useLocation } from "react-router-dom";

const FAQSection = ({ languageID }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation()
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    if (location?.pathname !== '/webinar' && languageID === undefined) {
      GetFAQListData();
    } else {
      setFaqs(languageID === 1 ? FaqObjMarathi : FaqObj)
    }
  }, []);

  const GetFAQListData = async () => {
    // debugger;
    try {
      const response = await FAQ();
      if (response) {
        if (response?.ResponseCode == 0) {
          if (response?.DATA) {
            const List = response?.DATA || [];
            setFaqs(List);
          }
        } else {
          console.error(response?.data?.errorMessage);
        }
      }
    } catch (error) {
      // setLoader(false);
      console.log(error);
    }
  };


  const FaqObj = [
    {
      QUESTION: "Who can attend this webinar?",
      ANSWER: "Anyone interested in learning the step-by-step process of Ganesh Puja, whether beginners or experienced devotees.",
    },
    {
      QUESTION: "In which language will the webinar be conducted?",
      ANSWER: "The webinar will be conducted in easy-to-understand language, with explanations in both English and Marathi.",
    },
    {
      QUESTION: "What topics will be covered in the webinar?",
      ANSWER: ` Detailed Ganesh Puja process: Sankalpa, offerings, Aarti, etc.
- Importance and meaning of each ritual
- Do’s & don’ts for a spiritual and meaningful celebration
- Practical tips and common mistakes to avoid`,
    },
    {
      QUESTION: "Will I get a recording if I miss the live session?",
      ANSWER: "No, we encourage you to participate in live session for maximum benefits.",
    },
    {
      QUESTION: "Can I ask questions during the webinar?",
      ANSWER: "Yes. However, considering the limited time available during the webinar, we'll note down your queries and we'll call you later for clarification on your query.",
    },
    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const FaqObjMarathi = [
    {
      QUESTION: "हा वेबिनार कोणासाठी आहे?",
      ANSWER:
        " गणेश पूजेची पायरी-पायरीने प्रक्रिया शिकण्याची इच्छा असलेल्या कोणासाठीही — मग ते नवशिके असोत किंवा अनुभवी भक्त.",
      color: "#ffa415",
    },
    {
      QUESTION: "वेबिनार कोणत्या भाषेत होणार आहे?",
      ANSWER:
        "वेबिनार सोप्या आणि समजण्यासारख्या भाषेत होईल, ज्यामध्ये स्पष्टीकरण इंग्रजी आणि मराठी दोन्ही भाषेत दिले जाईल.",
      color: "#fc5528",
    },
    {
      QUESTION: "वेबिनारमध्ये कोणते विषय घेतले जातील?",
      ANSWER:
        "सविस्तर गणेश पूजेची प्रक्रिया: संकल्प, नैवेद्य, आरती ,प्रत्येक विधीचे महत्त्व आणि त्यामागील अर्थ पूजेसाठी करावे व टाळावे असे मुद्दे ,उपयुक्त टिप्स व सामान्य चुका टाळण्याचे मार्ग",
      color: "#8139e7",
    },
    {
      QUESTION: " जर मी थेट सत्र चुकवलं तर रेकॉर्डिंग मिळेल का?",
      ANSWER:
        "नाही, अधिक लाभ मिळवण्यासाठी आम्ही तुम्हाला थेट सत्रात सहभागी होण्याची शिफारस करतो.",
      color: "#8139e7",
    },

    {
      QUESTION: "वेबिनार दरम्यान मी प्रश्न विचारू शकतो का?",
      ANSWER:
        "वेबिनारदरम्यान उपलब्ध असलेल्या मर्यादित वेळेचा विचार करून, आम्ही तुमचे प्रश्न नोंदवून ठेवू आणि तुमच्या प्रश्नाबाबत स्पष्टीकरणासाठी नंतर तुम्हाला फोन करू.",
      color: "#8139e7",
    },


    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-one faq-one--page">
      <div
        className="container"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="sec-title text-center">
          {languageID === 1 ? (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> प्रश्न आणि उत्तरे
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >

              </h3>
            </>
          ) : (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> FAQ's
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >
                Frequently Asked Questions.
              </h3>
            </>
          )}
        </div>
        <div className="row">
          <div className="col-xl-2"></div>
          <div className="col-xl-12">
            <div className="faq-one__accordion careox-accordion">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`accrodion ${activeIndex === index ? "active" : ""
                    }`}
                  style={{ "--accent-color": faq.color }}
                >
                  <div
                    className="accrodion-title"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h4>
                      <span
                        className="accrodion-title__number"
                        style={{ marginRight: "10px", fontWeight: "500" }}
                      ></span>
                      {faq.QUESTION}
                      <span className="accrodion-title__icon"></span>
                    </h4>
                  </div>
                  <div
                    className="accrodion-content"
                    style={{
                      maxHeight: activeIndex === index ? "200px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.5s ease-in-out",
                    }}
                  >
                    <div className="inner">
                      <p>{faq.ANSWER}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-xl-2"></div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
